// extracted by mini-css-extract-plugin
export default {"theme":"Theme__theme-suoD"};